import { AfterViewInit, Directive, ElementRef } from '@angular/core';

// TODO: Remove this directive once the bug is fixed
/**
 * Temporary code to fix Chrome browser crashing.
 * See: https://issues.chromium.org/issues/335553723?pli=1
 */
@Directive({
    selector: 'mat-form-field',
    standalone: true,
})
export class MatFormFieldFix implements AfterViewInit {
  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    this.removeAriaOwns();
  }

  private removeAriaOwns(): void {
    // console.log('MatFormFieldFix: removeAriaOwns');
    // Get the parent element of mat-select
    const parentElement = this.elementRef.nativeElement.parentElement;

    parentElement.querySelectorAll('[aria-owns]').forEach((element) => {
      element.removeAttribute('aria-owns');
    });
    parentElement.querySelectorAll('[aria-labelledby]').forEach((element) => {
      element.removeAttribute('aria-labelledby');
    });
  }
}
